export const setKeywordSearch = (state, param) => {
  state.search.keyword = param
  state.search.page = 1
  state.search.limit = 12
  state.search.scroll = 0
}

export const setSearchStatus = (state, param) => {
  state.search.status = param
  if (param === false) {
    state.search.keyword = ''
    state.search.page = 1
    state.search.limit = 12
    state.search.scroll = 0
  }
}

export const setMoreSearch = (state) => {
  state.search.page++
}

export const setSearchOldScroll = (state, param) => {
  state.search.scroll = param
}

export const setProductsList = (state, param) => {
  state.result.list = param.products
  state.result.count = param.products_count
  state.result.page = param.page
}

export const setProductsListLoadmore = (state, param) => {
  state.result.count = param.products_count
  state.result.page = param.page
}

export const setResultSearch = (state, param) => {
  state.search.result = param
}

export const setProductDetail = (state, param) => {
  state.detail = param
}

export const setProductVariant = (state, param) => {
  state.detail.product_variant = param
}

export const setResultSearchMore = (state, param) => {
  state.search.result.count = param.products_count
  state.search.result.page = param.page
  state.search.result.page_count = param.page_count
  param.products.forEach(element => {
    state.search.result.products.push(element)
  })
}

export const setSelectedQuantity = (state, param) => {
  state.selectedQuantity = param
}



// WEBPACK FOOTER //
// ./src/store/modules/products/mutations.js